import validate from "./validation/validate";
var utils = {
    validate: validate,
};
export default utils;
